"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkTraceName = checkTraceName;

var _urlParse = _interopRequireDefault(require("url-parse"));

var _runtime = _interopRequireDefault(require("./runtime"));

var _logger = _interopRequireDefault(require("../logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkTraceName(traceName) {
  if (!traceName) {
    _logger.default.warn('[performance-collect] route name 未定义，请确认 routeConfig 包含当前路径');

    return false;
  }

  return true;
}